import React from 'react';

import { Box, makeStyles, Theme, createStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

// Chat rows while the list loads, shaped like the real ones.
export const ChatListSkeleton: React.FC<{ rows?: number }> = ({ rows = 8 }) => {
  const classes = useStyles();

  return (
    <Box aria-busy="true" aria-label="Loading chats">
      {Array.from({ length: rows }, (_, index) => (
        <Box key={index} className={classes.row}>
          <Skeleton variant="circle" width={48} height={48} />
          <Box flex={1}>
            <Skeleton variant="text" width={`${50 + ((index * 17) % 35)}%`} height={20} />
            <Skeleton variant="text" width={`${60 + ((index * 23) % 30)}%`} height={18} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: { display: 'flex', alignItems: 'center', gap: 12, height: 72, padding: '8px 10px' },
  })
);
